import type { FC } from "react";
import type { Toast } from "./NotificationProvider";
import { NotificationItem } from "./NotificationItem";
import styles from "./Notification.module.css";

interface Props {
  toasts: Toast[];
  onRemove: (id: string) => void;
}

export const NotificationContainer: FC<Props> = ({ toasts, onRemove }) => (
  <div className={styles.container}>
    {toasts.map((toast) => (
      <NotificationItem key={toast.id} {...toast} onClose={onRemove} />
    ))}
  </div>
);
